
const NumberFormatLang = 'en-US'

export const roundDownToOneDecimalPlace = (num: number) => {
  return Math.floor(num * 10) / 10
}

export const displayDecimal = (num: number, CustomNumberFractionDigits: {
  minimumFractionDigits?: number
  maximumFractionDigits?: number
} = {}) => {
  return new Intl.NumberFormat(NumberFormatLang, CustomNumberFractionDigits).format(num)
}

export const displayTwoDecimal = (num: number) => {
  return displayDecimal(num, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
